// extracted by mini-css-extract-plugin
module.exports = {"container":"_3HPWR","desktop-container":"_2o6On","eachPartner":"_3oMiP","desktop-eachPartner":"_1rCr7"};